import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
export const useShowMobile = ({ desktopVideo, mobileVideo, pauseHiddenVideo }) => {
    const [showMobile, setShowMobile] = useState(((mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.muxData) && typeof window !== 'undefined' && window.innerWidth < 991) || false);
    useEffect(() => {
        const handleResize = () => {
            const mobileVidRef = document.getElementById(`background-video-${mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.id}`);
            const desktopVidRef = document.getElementById(`background-video-${desktopVideo.id}`);
            if (showMobile && typeof window !== 'undefined' && window.innerWidth > 991) {
                if ((mobileVidRef === null || mobileVidRef === void 0 ? void 0 : mobileVidRef.currentTime) && desktopVidRef && pauseHiddenVideo) {
                    desktopVidRef.currentTime = mobileVidRef.currentTime;
                }
                setShowMobile(false);
            }
            if ((mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.muxData) && !showMobile && window.innerWidth <= 991) {
                if ((desktopVidRef === null || desktopVidRef === void 0 ? void 0 : desktopVidRef.currentTime) && mobileVidRef && pauseHiddenVideo) {
                    mobileVidRef.currentTime = desktopVidRef.currentTime;
                }
                setShowMobile(true);
            }
        };
        const debounceHandleResize = debounce(handleResize, 100);
        window.addEventListener('resize', debounceHandleResize);
        return () => {
            window.removeEventListener('resize', debounceHandleResize);
        };
    }, [
        desktopVideo.id,
        mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.id,
        mobileVideo === null || mobileVideo === void 0 ? void 0 : mobileVideo.muxData,
        pauseHiddenVideo,
        showMobile,
    ]);
    return showMobile;
};
